module.exports = __webpack_public_path__ + "img/1728524531963-Screenshot_20240828_103845 - Miftahul Jannah.jpg.c9143431.webp";